import React from "react";
import { FunctionComponent } from "react";
import { Grid, makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import UserTypeRadio from "./UserTypeRadio";
import { AdapterButton } from "../../../components/Adopter";
import { Routes } from "../../../constants/routes";
import { useHistory } from "react-router-dom";
import FontIcon from "../../../components/FontIcon";

interface RegisterWidgetProps {}

const useStyles = makeStyles((theme: Theme) => ({
  body: {
    textAlign: "center",
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    flexWrap: "wrap",

    "& > .MuiGrid-item > .MuiFormControlLabel-root": {
      margin: "unset",
    },
  },
  label: {
    display: "inline-grid",
    textAlign: "center",
    height: "150",
    "& .MuiFormControlLabel-label": {
      marginTop: 10,
    },
  },
  button: {
    marginTop: 50,
    height: "64px",
    borderRadius: "32px",
    width: "40%",
    textAlign: "center",
    backgroundColor: theme.palette.primary.light,
  },
  serviceIcon: {
    fontSize: 14,
    marginRight: 8,
  },

  adapterButton: {
    backgroundColor: "transparent",
  },
}));

const RegisterWidget: FunctionComponent<RegisterWidgetProps> = ({
  ...props
}) => {
  const classes = useStyles();
  const [value, setValue] = React.useState<string>("school");
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };
  const history = useHistory();

  const redirectPage = (pageRoute: string) => {
    history.push(`/${pageRoute}`);
  };

  return (
    <div className={classes.body}>
      <RadioGroup
        value={value}
        onChange={handleRadioChange}
        className={classes.radioGroup}
      >
        <Grid item xs={6} sm={4}>
          <FormControlLabel
            onClick={() => redirectPage(Routes.REGISTER_SCHOOL)}
            className={classes.label}
            control={<UserTypeRadio iconName={"school"} />}
            value="school"
            label="School"
          />
        </Grid>
        <Grid item xs={6} sm={4}>
          <FormControlLabel
            onClick={() => redirectPage(Routes.REGISTER_AGENT)}
            className={classes.label}
            control={<UserTypeRadio iconName={"student"} />}
            value="agent"
            label="Agent"
          />
        </Grid>
        <Grid item xs={6} sm={4}>
          <FormControlLabel
            onClick={() => redirectPage(Routes.REGISTER_STUDENT)}
            className={classes.label}
            control={<UserTypeRadio iconName={"agent"} />}
            value="student"
            label="Student"
          />
        </Grid>
        <Grid item xs={6} sm={4}>
          <FormControlLabel
            onClick={() => redirectPage(Routes.REGISTER_PARENT)}
            className={classes.label}
            control={<UserTypeRadio iconName={"service-guardianship"} />}
            value="parent"
            label="Parent"
          />
        </Grid>
        <Grid item xs={6} sm={4}>
          <FormControlLabel
            onClick={() => redirectPage(Routes.REGISTER_TEACHER)}
            className={classes.label}
            control={<UserTypeRadio iconName={"service-internship"} />}
            value="teacher"
            label="Teacher"
          />
        </Grid>
        <Grid item xs={6} sm={4}>
          <FormControlLabel
            onClick={() => redirectPage(Routes.REGISTER_SERVICE_PROVIDER)}
            className={classes.label}
            control={<UserTypeRadio iconName={"services"} />}
            value="serviceProvider"
            label="Service Provider"
          />
        </Grid>
      </RadioGroup>
    </div>
  );
};

export default RegisterWidget;
